import Config from '@config';
import { isOfflineProduct, isOnlineProduct } from '@helpers/typeGuards/product';
import type {
  AxfoodBasicProductViewModel,
  AxfoodOfflineProductViewModel,
  AxfoodOrderProductViewModel,
  AxfoodProductDetailsViewModel,
} from '@occ/api-client';
import productMessages from '../messages/product.json';
import productFilterMessages from '../messages/productFilter.json';

export default function getQuantity(item: any): number {
  return parseFloat(
    String(item.pickQuantity > 0 ? item.pickQuantity : item.quantity > 0 ? item.quantity : item.qty > 0 ? item.qty : 0)
  );
}

export const getValidProductLabels = (
  product:
    | AxfoodProductDetailsViewModel
    | AxfoodOfflineProductViewModel
    | AxfoodOrderProductViewModel
    | AxfoodBasicProductViewModel,
  limit: number = product?.labels?.length || 0
): Array<string> => {
  const labels = [...(product?.labels || [])];

  if (isOnlineProduct(product) && product?.isDrugProduct && !product?.nicotineMedicalProduct) {
    labels?.unshift('medicine-label');
  }

  return labels
    ?.filter((label: string) => !Config.EXCLUDED_LABELS.includes(label) && !label.endsWith('_facet'))
    ?.filter((label: string) => label !== 'ecological')
    .slice(0, limit);
};

export const getPdpAgeRestrictionImage = (
  product: AxfoodProductDetailsViewModel | AxfoodOfflineProductViewModel
): string => {
  if (isOfflineProduct(product)) {
    return '';
  }
  const labels = getValidProductLabels(product, 100);

  if (!labels.includes('age_restricted_18')) return '';

  if (product.tobaccoFreeNicotineProduct) {
    return 'age_restricted_18_nicotine_snuff.svg';
  } else if (product.tobaccoProduct) {
    return 'age_restricted_18_tobacco.svg';
  } else {
    return 'age_restricted_18.svg';
  }
};

// Z-code (product label) translation helpers
// Product labels are runtime strings from BE, but we only have translations for a finite set of known keys.
export type ProductLabelKey = Extract<keyof typeof productMessages.label, string>;

export const isProductLabelKey = (value: string): value is ProductLabelKey => value in productMessages.label;

// Product filter category translation helpers
// Category codes are runtime strings from BE, but we only have translations for a finite set of known keys.
export type ProductFilterCategoryKey = Extract<keyof typeof productFilterMessages.categories, string>;

export const isProductFilterCategoryKey = (value: string): value is ProductFilterCategoryKey =>
  value in productFilterMessages.categories;
